// extracted by mini-css-extract-plugin
export default {"main":"App_main__nhgh3","container":"App_container__Rt8T2","heart":"App_heart__ku7+5","beat":"App_beat__ghkZZ","footer":"App_footer__aawhi","link":"App_link__kpF6Q"};